//Library
import React, { Component } from 'react';
import Swal from 'sweetalert2';
//redux
import { connect } from 'react-redux';
import { setTsrFund, getPDF } from '../../action/anueInfoAction';

class Step1 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectTrsFund: undefined
        }
    }

    nextStepSubmit() {
        
        if (this.state.selectTrsFund !== undefined){
            this.props.getPDF([this.state.selectTrsFund.fundID])
            this.props.setTsrFund(this.state.selectTrsFund);
            this.props.nextStep();
        }
        else
            Swal.fire("請選取要轉換的基金。");
    }

    render() {
        return <fieldset>
            <div className="featureBox">
                <div className="blackTitle">
                    <div className="transferout">轉出</div>
                    {
                        this.props.TSRDataInfo !== undefined ?
                            <span>（{this.props.TSRDataInfo.outFundID}）{this.props.TSRDataInfo.outFundName}</span> : ""
                    }
                </div>
                <div className="redTitle">
                    <div className="transferin">轉入</div>
                    <span>請點選您所想要轉入及變更定期定額扣款的新基金</span>
                </div>
                <div className="transfundblock">
                    {
                        this.props.TSRDataInfo !== undefined ?
                            this.props.TSRDataInfo.inFunds.map(({ fundID, intro, shortName }, index) => {
                                return <div key={index}>
                                    <input type="radio" name="fund" value={fundID} id={fundID} onClick={() => { this.setState({ selectTrsFund: { fundID, intro, shortName } }) }} />
                                    <label htmlFor={fundID}>
                                        <p className="pText">（{fundID}）{shortName}
                                            <span>{intro}</span>
                                        </p>
                                    </label>
                                </div>
                            }) : ""
                    }
                </div>
            </div>
            <input type="button" name="next" className="next btnblock" value="下一步" onClick={() => { this.nextStepSubmit() }} />
        </fieldset>
    }

}
function mapStateToProps(state) {
    return {
        TSRDataInfo: state.anueInfoState.TSRDataInfo,
    };
}
export default connect(mapStateToProps, { setTsrFund, getPDF })(Step1);